import { Archive, ArchiveRestore, Trash2, X } from "lucide-react";
import { cn } from "~/shared/lib/utils";
import { SECTION_V5 } from "./design-tokens";

export interface SectionBulkBarProps {
    selectedCount: number;
    onCancel: () => void;
    onArchive: () => void;
    onDelete: () => void;
    /** When provided, shows a "Restore" button instead of "Archive". */
    onUnarchive?: () => void;
    cancelLabel?: string;
    archiveLabel?: string;
    unarchiveLabel?: string;
    deleteLabel?: string;
    /** Renders the delete button greyed-out and non-clickable with a tooltip. */
    deleteDisabled?: boolean;
    deleteDisabledHint?: string;
    className?: string;
}

export function SectionBulkBar({
    selectedCount,
    onCancel,
    onArchive,
    onDelete,
    onUnarchive,
    cancelLabel = "Cancel",
    archiveLabel = "Archive",
    unarchiveLabel = "Restore",
    deleteLabel = "Delete",
    deleteDisabled = false,
    deleteDisabledHint,
    className,
}: SectionBulkBarProps) {
    return (
        <div className={cn("flex w-full items-center gap-3 px-4 md:px-8", className)}>
            <span className={SECTION_V5.bulkBarCounter}>{selectedCount} selected</span>
            <div className={SECTION_V5.bulkBarSpacer}>
                <button
                    type="button"
                    onClick={onCancel}
                    aria-label={cancelLabel}
                    className={cn(SECTION_V5.bulkBarButton, "rounded-md border bg-background")}
                >
                    <X className="size-4 md:hidden" aria-hidden />
                    <span className="hidden md:inline">{cancelLabel}</span>
                </button>
                {onUnarchive ? (
                    <button
                        type="button"
                        onClick={onUnarchive}
                        aria-label={unarchiveLabel}
                        className={cn(SECTION_V5.bulkBarButton, "rounded-md border bg-background")}
                    >
                        <ArchiveRestore className="size-4 md:hidden" aria-hidden />
                        <span className="hidden md:inline">{unarchiveLabel}</span>
                    </button>
                ) : (
                    <button
                        type="button"
                        onClick={onArchive}
                        aria-label={archiveLabel}
                        className={cn(SECTION_V5.bulkBarButton, "rounded-md border bg-background")}
                    >
                        <Archive className="size-4 md:hidden" aria-hidden />
                        <span className="hidden md:inline">{archiveLabel}</span>
                    </button>
                )}
                <button
                    type="button"
                    onClick={onDelete}
                    disabled={deleteDisabled}
                    title={deleteDisabled ? deleteDisabledHint : undefined}
                    aria-label={deleteLabel}
                    className={cn(
                        SECTION_V5.bulkBarButton,
                        "rounded-md border bg-destructive text-destructive-foreground",
                        deleteDisabled && "cursor-not-allowed opacity-40",
                    )}
                >
                    <Trash2 className="size-4 md:hidden" aria-hidden />
                    <span className="hidden md:inline">{deleteLabel}</span>
                </button>
            </div>
        </div>
    );
}
